/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/confetti'
export default icon
